export default "__VITE_ASSET__B2_6T0eQ__"